///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { _round } from '../../../shared/utils';
import { PositionDTO } from '../../../generated/shared-types.model';

export class GtthPosition {
    private static readonly roundDigitsAfterComma = 6;
    private _latitude: number;

    get latitude(): number {
        return this._latitude;
    }

    set latitude(value: number) {
        this._latitude = _round(value, GtthPosition.roundDigitsAfterComma);
    }

    private _longitude: number;

    get longitude(): number {
        return this._longitude;
    }

    set longitude(value: number) {
        this._longitude = _round(value, GtthPosition.roundDigitsAfterComma);
    }

    static fromEventObject(eventObject: google.maps.MapMouseEvent): GtthPosition {
        const position = new GtthPosition();
        position.longitude = _round(eventObject.latLng.lng(), GtthPosition.roundDigitsAfterComma);
        position.latitude = _round(eventObject.latLng.lat(), GtthPosition.roundDigitsAfterComma);
        return position;
    }

    static fromValues(longitude: number, latitude: number): GtthPosition {
        const position = new GtthPosition();
        position.longitude = _round(longitude, GtthPosition.roundDigitsAfterComma);
        position.latitude = _round(latitude, GtthPosition.roundDigitsAfterComma);
        return position;
    }

    equals(otherPosition: GtthPosition): boolean {
        return this.longitude === otherPosition.longitude && this.latitude === otherPosition.latitude;
    }

    toLatLngLiteral(): google.maps.LatLngLiteral {
        return {
            lat: this.latitude,
            lng: this.longitude
        } as google.maps.LatLngLiteral;
    }

    toLatLng(google: any): google.maps.LatLng {
        return new google.maps.LatLng(this.latitude, this.longitude);
    }

    toPositionDto(): PositionDTO {
        return {
            latitude: this.latitude,
            longitude: this.longitude
        } as PositionDTO;
    }
}
